import {
    getUserAvatarBackgroundColor,
    warningColor,
    getUserAvatarProcessingUrl,
} from '../../../assets/styles/style-helpers';

/**
 * Adds the event handlers for events potentially dispatched by the application.
 */
 const _addEventHandlers = () => {
    window.addEventListener(window.$wx?.mfeLoginCompleteEvent?.type, () => {
        _setUserInfo();
    });
    window.addEventListener(
        window.$wx?.mfeProfilePhotoSetEvent?.type,
        _setUserAvatar
    );
}

/**
 * Sets the initials that appear in a user's avatar that has no associated profile photo.
 * @param {string} initials The first and last initials of the user.
 */
 const _setAvatarInitials = (initials) => {
    const avatarInitials = document.getElementById('user-menu-avatar-initials');
    avatarInitials.innerText = initials;
};

/**
 * Sets the currently logged-in user's avatar or profile photo.
 * @returns {void} Void.
 */
 const _setUserAvatar = () => {
    const currentUser = JSON.parse(localStorage.getItem('wxPortal.User'));
    const userAvatarElement = document.getElementById(
        'user-menu-profile-picture'
    );

    if (!currentUser || !userAvatarElement) {
        return;
    }

    if (currentUser.profile_photo) {
        userAvatarElement.style[
            'background-image'
        ] = `url("${getUserAvatarProcessingUrl(currentUser.profile_photo)}")`;
        userAvatarElement.style['border'] = `2px solid ${warningColor}`;
        _setAvatarInitials('');
    } else {
        userAvatarElement.style.removeProperty('background-image');
        userAvatarElement.style.removeProperty('border');

        if (currentUser.first_name && currentUser.last_name) {
            const userInitials =
                currentUser.first_name[0] + currentUser.last_name[0];
            userAvatarElement.style['background-color'] =
                getUserAvatarBackgroundColor(`${currentUser.first_name} ${currentUser.last_name}`);
            _setAvatarInitials(userInitials.toUpperCase());
        }
    }
};

/**
 * Sets the user's full name in the info bar, and then their avatar or profile photo.
 * @returns {void} Void.
 */
 const _setUserInfo = () => {
    const currentUser = JSON.parse(localStorage.getItem('wxPortal.User'));

    if (!currentUser) {
        return;
    }

    const userFullName = document.getElementById('user-menu-full-name');
    if (userFullName) {
        userFullName.innerText = `${currentUser.first_name} ${currentUser.last_name}`;
    }

    _setUserAvatar();
};

/**
 * Renders the user menu button and sets up the event handlers.
 */
const renderUserMenuButton = () => {
    _addEventHandlers();
    _setUserInfo();
}

export default renderUserMenuButton;